export class vwTask {
  TaskCode : string;
  TaskName: string;
  TimeLimit: number;
  TaskTime: number;
  AssignedToId : number;
  AssignedToName : string;
  AssignedToRealName : string;
  InspectorId: number;
  InspectorName: string;
  InspectorRealName : string;
  CreatedById: number;      // ezt is tolteni !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  CreatedByName: string;
  Ready: boolean;
  Accepted: boolean;
  DailyTaskId: number;
  FinishTime: number;
  InspectTime:number;
  InspectTimeStr: string;
  TaskTimeStr: string;
  FinishTimeStr : string;
  TaskStartTimeStr: string;
  TaskEndTimeStr: string;
  FinishDate: string;
  InspectDate : string;
  TaskState: string;
  TaskStateChanged: string;
  TimeSinceLastChange: number;
  CleaningTypesId : number;
  Comment: string;
  Need_Cleaning : boolean;
}
